module.exports = __webpack_public_path__ + "media/application/images/process_steps/bookstack_hero-c0c39f19322ee415152a51b855a4bd04.png";